var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckGradient2020 = function SvgCheckGradient2020(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.751 17.677a8.1 8.1 0 0 0 3.25.656 8.1 8.1 0 0 0 3.25-.656 8.4 8.4 0 0 0 2.645-1.782 8.4 8.4 0 0 0 1.781-2.646 8.1 8.1 0 0 0 .656-3.25 8.1 8.1 0 0 0-.656-3.25 8.4 8.4 0 0 0-1.782-2.645 8.4 8.4 0 0 0-2.646-1.781 8.1 8.1 0 0 0-3.25-.656 8.1 8.1 0 0 0-3.25.656 8.4 8.4 0 0 0-2.645 1.782A8.4 8.4 0 0 0 2.323 6.75a8.1 8.1 0 0 0-.656 3.25 8.1 8.1 0 0 0 .656 3.25 8.4 8.4 0 0 0 1.782 2.645 8.4 8.4 0 0 0 2.646 1.781"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#check_gradient_20_20_svg__a)",
    d: "M8.755 11.883 6.717 9.845a.64.64 0 0 0-.458-.187.62.62 0 0 0-.466.187.63.63 0 0 0-.19.462.63.63 0 0 0 .19.462L8.2 13.177a.76.76 0 0 0 .555.237q.316 0 .555-.237l4.88-4.88a.64.64 0 0 0 .187-.459.62.62 0 0 0-.187-.466.63.63 0 0 0-.462-.19.63.63 0 0 0-.462.19zm1.246 6.45a8.1 8.1 0 0 1-3.25-.656 8.4 8.4 0 0 1-2.646-1.78 8.4 8.4 0 0 1-1.782-2.646A8.1 8.1 0 0 1 1.667 10q0-1.728.656-3.25a8.4 8.4 0 0 1 1.78-2.646A8.4 8.4 0 0 1 6.75 2.323 8.1 8.1 0 0 1 10 1.667q1.729 0 3.25.656a8.4 8.4 0 0 1 2.646 1.78 8.4 8.4 0 0 1 1.782 2.646 8.1 8.1 0 0 1 .656 3.25 8.1 8.1 0 0 1-.656 3.25 8.4 8.4 0 0 1-1.78 2.646 8.4 8.4 0 0 1-2.646 1.782 8.1 8.1 0 0 1-3.25.656"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "check_gradient_20_20_svg__a",
    x1: 18.333,
    x2: 1.581,
    y1: 14.012,
    y2: 13.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FE8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FE8BC"
  })))));
};
export default SvgCheckGradient2020;